var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"has-text-gray-dark",attrs:{"aria-live":"polite"}},[_vm._v("\n    "+_vm._s(_vm.installmentPeriod)+"\n  ")])}
var staticRenderFns = []

export { render, staticRenderFns }